import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum LongTermAssets {
    RAT = "LongTermRAT",
    RAT_DYING = "LongTermRAT_DYING",

    BACKGROUND = "LongTermBACKGROUND",
    RAT_BOX = "LongTermRAT_BOX",
    SMOKE = "LongTermSMOKE",

    INTRO = "LongTermINTRO",
    RAT_DEATH_AUDIO = "LongTermRAT_DEATH_AUDIO",
}

export function loadAssets(game: Phaser.Game) {
    game.load.spritesheet(LongTermAssets.RAT, CCUtils.asset("second-hand/long-term/rat.png"), 290, 187)
    game.load.spritesheet(LongTermAssets.RAT_DYING, CCUtils.asset("second-hand/long-term/rat-dying.png"), 289, 137)

    game.load.image(LongTermAssets.BACKGROUND, CCUtils.asset("second-hand/long-term/rat-table.png"))
    game.load.image(LongTermAssets.RAT_BOX, CCUtils.asset("second-hand/long-term/rat-box.png"))
    game.load.image(LongTermAssets.SMOKE, CCUtils.asset("second-hand/long-term/smoke.png"))

    game.load.audio(LongTermAssets.INTRO, CCUtils.asset("second-hand/long-term/audio/long-term-intro.mp3"))
    game.load.audio(LongTermAssets.RAT_DEATH_AUDIO, CCUtils.asset("second-hand/long-term/audio/rat-dying.mp3"))
}
